module.exports = __webpack_public_path__ + "media/tax_identifications/green-check-48524695.png";